import { post as buildingSaasWithCloudflare } from './building-saas-with-cloudflare'
import { post as deployingEdgeFirstApplications } from './deploying-edge-first-applications'
import { post as modernAuthenticationPatterns } from './modern-authentication-patterns'
import { post as typeSafeApisWithTrpc } from './type-safe-apis-with-trpc'
import type { BlogPost } from './types'

export type { BlogPost } from './types'

const posts: BlogPost[] = [
  buildingSaasWithCloudflare,
  typeSafeApisWithTrpc,
  deployingEdgeFirstApplications,
  modernAuthenticationPatterns,
]

export function getBlogPost(slug: string): BlogPost | undefined {
  return posts.find((post) => post.slug === slug)
}

export function getAllBlogPosts(): BlogPost[] {
  return posts.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
}
